import * as React from "react";
import { isPermitted } from "util/PermissionsMixin";
import WatchlistDomain from "watchlist/domainActions/WatchlistDomain";
import watchlistFields from "security-content/mappings/watchlistFields";
const fieldIsOnWatchlist = (watchlistStatus, wlFieldType, field) => {
  var _a;
  return !!((_a = watchlistStatus == null ? void 0 : watchlistStatus[wlFieldType]) == null ? void 0 : _a.includes(field));
};
const WatchlistAddition = {
  handler: (lookupTableKey) => ({ value }) => WatchlistDomain.update(lookupTableKey, value),
  isHidden: (watchlistFieldType, field, currentUserPermissions, watchlistStatus) => !isPermitted(currentUserPermissions, "watchlist:edit") || !watchlistFields[watchlistFieldType].includes(field) || fieldIsOnWatchlist(watchlistStatus, watchlistFieldType, field)
};
const WatchlistRemoval = {
  handler: (lookupTableKey) => ({ value }) => WatchlistDomain.delete(lookupTableKey, value),
  isHidden: (watchlistFieldType, field, currentUserPermissions, watchlistStatus) => !isPermitted(currentUserPermissions, "watchlist:edit") || !watchlistFields[watchlistFieldType].includes(field) || !fieldIsOnWatchlist(watchlistStatus, watchlistFieldType, field)
};
const WatchlistActionHelp = (isEnabled) => {
  if (!isEnabled) {
    return {
      title: "Action not possible",
      description: /* @__PURE__ */ React.createElement(React.Fragment, null, "This field value is an array. Removing multiple values from a watchlist is currently not supported. If you want to add or remove included values you can manually edit the watchlist lookup table.")
    };
  }
  return void 0;
};
export { WatchlistAddition, WatchlistRemoval, WatchlistActionHelp };
